import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RouteCard = ({ 
  route, 
  isSelected, 
  onSelect, 
  onEdit, 
  onDelete, 
  onDuplicate,
  onToggleStatus,
  isExpanded,
  onToggleExpand 
}) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('tr-TR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden transition-smooth hover:shadow-md">
      <div className="p-4">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onSelect(route?.id, e?.target?.checked)}
              className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary/20 mt-1 flex-shrink-0"
              aria-label={`${route?.route_name} seç`}
            />
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-foreground text-lg mb-1 truncate">
                {route?.route_name}
              </h3>
              <button
                onClick={() => onToggleStatus(route?.id)}
                className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium transition-smooth ${
                  route?.is_active
                    ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
                }`}
              >
                <div className={`w-1.5 h-1.5 rounded-full ${route?.is_active ? 'bg-success' : 'bg-muted-foreground'}`} />
                {route?.is_active ? 'Aktif' : 'Pasif'}
              </button>
            </div>
          </div>
          <button
            onClick={() => onToggleExpand(route?.id)}
            className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-muted transition-smooth flex-shrink-0"
            aria-label={isExpanded ? 'Daralt' : 'Genişlet'}
          >
            <Icon 
              name={isExpanded ? "ChevronUp" : "ChevronDown"} 
              size={20} 
              color="var(--color-foreground)" 
            />
          </button>
        </div>

        <div className="space-y-2 mb-3">
          <div className="flex items-start gap-2">
            <Icon name="MapPin" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground mb-0.5">Başlangıç</p>
              <p className="text-sm text-foreground">{route?.start_point}</p>
            </div>
          </div>
          <div className="flex items-start gap-2">
            <Icon name="MapPin" size={16} color="var(--color-accent)" className="mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground mb-0.5">Bitiş</p>
              <p className="text-sm text-foreground">{route?.end_point}</p>
            </div>
          </div>
          {route?.departure_times?.length > 0 && (
            <div className="flex items-start gap-2">
              <Icon name="Clock" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground mb-1">Kalkış Saatleri</p>
                <div className="flex flex-wrap gap-1.5">
                  {route?.departure_times?.slice(0, 3)?.map((time, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center px-2 py-0.5 bg-primary/10 text-primary rounded text-xs font-medium"
                    >
                      {time}
                    </span>
                  ))}
                  {route?.departure_times?.length > 3 && (
                    <span className="inline-flex items-center px-2 py-0.5 bg-muted text-muted-foreground rounded text-xs font-medium">
                      +{route?.departure_times?.length - 3}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {isExpanded && (
          <div className="pt-3 border-t border-border space-y-3">
            {route?.departure_times?.length > 3 && (
              <div className="flex items-start gap-2">
                <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
                <div className="flex-1">
                  <p className="text-xs text-muted-foreground mb-2">Tüm Kalkış Saatleri</p>
                  <div className="flex flex-wrap gap-1.5">
                    {route?.departure_times?.map((time, index) => (
                      <span
                        key={index}
                        className="inline-flex items-center px-2 py-1 bg-primary/10 text-primary rounded text-xs font-medium"
                      >
                        {time}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" />
              <div>
                <p className="text-xs text-muted-foreground">Son Güncelleme</p>
                <p className="text-sm text-foreground">{formatDate(route?.last_modified)}</p>
              </div>
            </div>

            <div className="flex items-center gap-2 pt-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => onEdit(route)}
                iconName="Pencil"
                iconPosition="left"
                iconSize={14}
                className="flex-1"
              >
                Düzenle
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => onDuplicate(route)}
                iconName="Copy"
                iconPosition="left"
                iconSize={14}
                className="flex-1"
              >
                Kopyala
              </Button>
              <Button
                variant="outline"
                size="icon"
                onClick={() => onDelete(route)}
                iconName="Trash2"
                iconSize={16}
                className="hover:bg-destructive/10 hover:text-destructive hover:border-destructive"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RouteCard;